export { default } from './PoweredBy'
